export default __webpack_public_path__ + "static/media/fastingtime@3x.166cc0ec.jpg";